export const reloadReasons:Map<string, string> = new Map([
  ['INCORRECT_MAPPING_TRANSACTIONS', 'Incorrect Mapping - Transactions'],
  ['INCORRECT_MAPPING_CONFIGURATION', 'Incorrect Mapping - New Configuration'],
  ['INCORRECT_MAPPING_OTHER', 'Incorrect Mapping - Other'],
  ['FIDIL_CREATION_FAILURE', 'FIDIL Creation Failure'],
  ['LATE_EXTRACT_FILES', 'Late Extract File(s)'],
  ['KRP_WHITELIST', 'KRP Whitelist'],
  ['EDW_WHITELIST', 'EDW Whitelist'],
  ['PIG_TRANSFORMATION', 'Pig Transformation'],
  ['CONSULTING_RELOAD', 'Consulting Reload'],
  ['AD_HOC_FILES_ADDED', 'Ad Hoc Files Added'],
  ['CORRECTED_DATA', 'Corrected Data'],
  ['TIMEOUT_DATABASE_LOCK', 'Timeout/Database Lock'],
  ['POSTING_FILE_CREATION_FAILURE_CORRECTION', 'Posting File Creation Failure/Correction'],
  ['OTHER', 'Other'],
]);

export default reloadReasons;
